//fetchReportDashboard
import {  globalAxios,   } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    search_config: {},
    store_payment_list: [],
    food_order_report: [],
    freedelivery_order_report: [],
    messenger_order_report: [],
    export_food_format: [],
    export_freedelivery_format: [],
    export_messegner_format: [],
    food_summary: {
      total_orders: 0,
      foodandmessenger: { food: 0, messenger: 0 },
      foodcompletecancel: { completed: 0, canceled: 0 },
      freedeliverycompletecancel: { completed: 0, canceled: 0 },
      messengercompletecancel: { completed: 0, canceled: 0 },
    },
  },
  mutations: {
    resetState(state) {
      state.search_config = {};
      state.store_payment_list = [];
      state.food_order_report = [];
      state.freedelivery_order_report = [];
      state.messenger_order_report = [];
      state.export_food_format = [];
      state.export_freedelivery_format = [];
      state.export_messegner_format = [];
      state.food_summary = {
        total_orders: 0,
        foodandmessenger: { food: 0, messenger: 0 },
        foodcompletecancel: { completed: 0, canceled: 0 },
        freedeliverycompletecancel: { completed: 0, canceled: 0 },
        messengercompletecancel: { completed: 0, canceled: 0 },
      };
    },
    getStorePayment(state, data) {
      state.store_payment_list = data;
    },
    getSummaryExportMessenger(state) {
      let total_net_price = 0;
      for (let val of state.export_messegner_format) {
        total_net_price = total_net_price + parseFloat(val.Price);
      }
      let push_data = {
        Vehicle_type: "Total",
        Price: total_net_price
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      };
      state.export_messegner_format.push(push_data);
    },
    fetchOrderReport(state, data) {
      state.freedelivery_order_report = [];
      state.export_freedelivery_format = [];
      state.food_order_report = [];
      state.export_food_format = [];
      state.messenger_order_report = [];
      state.export_messegner_format = [];
      for (let val of data) {
        if (val.order_type == 1) {
          let push_data = {
            order_id: val.order_id,
            no: state.food_order_report.length + 1,
            no_default: state.food_order_report.length + 1,
            Order_code: val.order_code,
            order_base_code: val.order_base_code,
            Date_time: val.order_time_start,
            Store: val.order_store,
            Customer: val.order_customer_full_name,
            order_payment: val.order_payment,
            Status: val.order_status,
            Remark: val.order_note,
          };
          state.food_order_report.push(push_data);
          const obj1 = JSON.parse(JSON.stringify(push_data));
          delete obj1.order_id;
          delete obj1.no_default;
          state.export_food_format.push(obj1);
        } else if (val.order_type == 2) {
          let push_data = {
            order_id: val.order_id,
            no: state.messenger_order_report.length + 1,
            no_default: state.messenger_order_report.length + 1,
            Order_code: val.order_code,
            order_base_code: val.order_base_code,
            Rider: val.order_rider_full_name,
            Vehicle_type: val.order_vehicle_type,
            Start_point: val.order_point_start,
            End_point: val.order_point_end,
            Price: val.order_net_price
              ? parseFloat(val.order_net_price)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "0.00",
            order_payment: val.order_payment,
            status: val.order_status,
          };
          state.messenger_order_report.push(push_data);
          const obj1 = JSON.parse(JSON.stringify(push_data));
          delete obj1.order_id;
          delete obj1.no_default;
          obj1.Price = obj1.Price.toString().replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ","
          );
          state.export_messegner_format.push(obj1);
        } else if (val.order_type == 3) {
          let push_data = {
            order_id: val.order_id,
            no: state.freedelivery_order_report.length + 1,
            no_default: state.freedelivery_order_report.length + 1,
            Order_code: val.order_code,
            order_base_code: val.order_base_code,
            Date_time: val.order_time_start,
            Store: val.order_store,
            Customer: val.order_customer_full_name,
            order_payment: val.order_payment,
            Status: val.order_status,
            Remark: val.order_note,
          };
          state.freedelivery_order_report.push(push_data);
          const obj1 = JSON.parse(JSON.stringify(push_data));
          delete obj1.order_id;
          delete obj1.no_default;
          state.export_freedelivery_format.push(obj1);
        }
      }
    },
    getExportFreeDeliveryReport(state) {
      state.export_freedelivery_format = [];
      for (let val of state.freedelivery_order_report) {
        const obj1 = JSON.parse(JSON.stringify(val));
        delete obj1.no_default;
        delete obj1.order_id;
        state.export_freedelivery_format.push(obj1);
      }
    },
    getExportMessReport(state) {
      state.export_messegner_format = [];
      for (let val of state.messenger_order_report) {
        const obj1 = JSON.parse(JSON.stringify(val));
        delete obj1.no_default;
        delete obj1.order_id;
        obj1.Price = obj1.Price.toString().replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        );
        state.export_messegner_format.push(obj1);
      }
    },
    getExportFoodReport(state) {
      state.export_food_format = [];
      for (let val of state.food_order_report) {
        const obj1 = JSON.parse(JSON.stringify(val));
        delete obj1.no_default;
        delete obj1.order_id;
        state.export_food_format.push(obj1);
      }
    },
    fetchFoodSummary(state, data) {
      let count_food = {
        completed: 0,
        canceled: 0,
      };
      let count_messenger = {
        completed: 0,
        canceled: 0,
      };
      let count_freedelivery = {
        completed: 0,
        canceled: 0,
      };
      for (let val of data) {
        if (val.order_type == 1 && val.order_status == "completed") {
          count_food.completed++;
        } else if (val.order_type == 1 && val.order_status == "cancel") {
          count_food.canceled++;
        } else if (val.order_type == 2 && val.order_status == "completed") {
          count_messenger.completed++;
        } else if (val.order_type == 2 && val.order_status == "cancel") {
          count_messenger.canceled++;
        } else if (val.order_type == 3 && val.order_status == "completed") {
          count_freedelivery.completed++;
        } else if (val.order_type == 3 && val.order_status == "cancel") {
          count_freedelivery.canceled++;
        }
      }
      state.food_summary.total_orders = data.length;
      state.food_summary.foodandmessenger = {
        food: count_food.completed + count_food.canceled,
        messenger: count_messenger.completed + count_messenger.canceled,
        freedelivery:
          count_freedelivery.completed + count_freedelivery.canceled,
      };
      state.food_summary.foodcompletecancel = count_food;
      state.food_summary.messengercompletecancel = count_messenger;
      state.food_summary.freedeliverycompletecancel = count_freedelivery;
    },
  },
  actions: {
    fetchOrderReportByDistrict({ rootState, state, dispatch, commit }, payload) {
      let url = `/api/v1/${
        rootState.backOffice.province
      }/search_by_district/order_report_food/order_type/order_status/datetime_start/datetime_end/${
        state.search_config.order_type
      }/${state.search_config.order_status}/${
        state.search_config.datetime_start
        }/${state.search_config.datetime_end}`;
      let body = {
        district: payload.district, 
        payment: payload.payment == 0 ? undefined : payload.payment
      };
      return globalAxios
        .post(url, body)
        .then((res) => {
          commit("fetchFoodSummary", res.data);
          commit("fetchOrderReport", res.data);
          commit("getSummaryExportMessenger");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async fetchOrderReport({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchReportDashboard_fetchOrderReport +
        config_path.order_type +
        "/" +
        config_path.order_status +
        "/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;
      
      if (config_path.payment != 0) { 
        url += `?payment=${config_path.payment}`
      } 

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("fetchFoodSummary", res.data);
        commit("fetchOrderReport", res.data);
        commit("getSummaryExportMessenger");
      }
    },
    async getStorePayment({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchReportDashboard_getStorePayment +
        config_path.store_id +
        "/" +
        config_path.order_status +
        "/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getStorePayment", res);
      }
    },
  },
  getters: {},
};
